module.exports = __webpack_public_path__ + "static/media/20191022_105458_wide-scaled.01540a3f.jpg";